import * as Styles from "./styles.css";
import * as M from "@discovery/prelude/lib/data/maybe";
import { cn } from "@discovery/classnames";
import { Typography, Tags, HeaderVariants } from "../../atoms/typography";
import { Icon, Icons } from "../icon";
export var PlayWithLabelVariants;
(function (PlayWithLabelVariants) {
    PlayWithLabelVariants["smallLabel"] = "smallLabel";
    PlayWithLabelVariants["largeLabel"] = "largeLabel";
})(PlayWithLabelVariants || (PlayWithLabelVariants = {}));
export const PlayWithLabel = ({ onClickM = M.empty(), labelM = M.of(""), classNameM = M.empty(), variant, }) => (React.createElement("div", { className: cn(Styles.container, classNameM), onClick: M.fromMaybe(onClickM, undefined) },
    React.createElement(Icon, { type: Icons.PlayButton, className: Styles.play }),
    React.createElement(Typography, { classNameM: M.of(cn(Styles.playLabel, {
            [Styles.labelStyles]: variant === PlayWithLabelVariants.largeLabel,
        })), variant: HeaderVariants.headingFive, tag: Tags.h5 },
        React.createElement(React.Fragment, null, M.fromMaybe(labelM, "")))));

